import script from "./VBreadcrumbsList.vue?vue&type=script&setup=true&lang=js"
export * from "./VBreadcrumbsList.vue?vue&type=script&setup=true&lang=js"

import "./VBreadcrumbsList.vue?vue&type=style&index=0&id=12b81511&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b81511"]])

export default __exports__